export enum EHistoryItemType {
  CREATED = 'CREATED',
  CANCELED = 'CANCELED',
  STATUS_CHANGED = 'STATUS_CHANGED',
}
